export default "__VITE_ASSET__C9_pj8cz__"